import Icon from '../components/Icon.vue'

Icon.register({
  'cookie-bite': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M510.5 255.8c4.1 27.3-0.3 55.3-12.9 79.9l-35.1 68.9c-10.8 21.1-36.7 47-57.8 57.8l-69.1 35.2c-24.8 12.7-53 17.1-80.5 12.8l-76.7-12.1c-23.4-3.7-56-20.3-72.7-37.1l-54.8-54.8c-16.8-16.8-33.4-49.5-37.2-73l-12.1-76.3c-0.9-5.7-1.6-15-1.6-20.7 0-17.6 6.5-44.5 14.5-60.2l35.1-68.9c10.8-21.1 36.7-47 57.8-57.8l69.1-35.2c24.6-12.5 52.5-17 79.7-12.8 0.9 70 57.7 126.5 127.9 126.5 0 70.2 56.5 127 126.5 127.9zM176 368c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM208 208c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM368 336c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z'
      }
    ]
  }
})
